module.exports = __webpack_public_path__ + "img/img-work_detail_9.d2eeaa5d.png";